export class ServiceUnavailableError extends Error {

}